export default __webpack_public_path__ + "static/media/sql_logo.a8f1860f.png";